import "./Faq.css";
import FaqText from "./FaqText";
import GoHomeTimer from "./GoHomeTimer";
import Header from "./Header";
import Text from "./Text";

const Faq = () => {
  return (
    <div className="image-bg-container">
      <GoHomeTimer />
      <div className="pod-faq-container">
        <Header />
        <div className="pod-faq-title">
          <Text type="subtitle"> Frequently Asked Questions</Text>
        </div>
        <div className="pod-faq-scroll">
          <div className="pod-faq-text">
            <FaqText />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faq;
